var render, staticRenderFns
import script from "./baseSimulator.vue?vue&type=script&lang=js"
export * from "./baseSimulator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dayanamartinez/Developer/laas_simulator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25c1708b')) {
      api.createRecord('25c1708b', component.options)
    } else {
      api.reload('25c1708b', component.options)
    }
    
  }
}
component.options.__file = "src/components/Flujo/Simuladores/baseSimulator.vue"
export default component.exports